(function($) {
  var userCanReadParentView = false;
  var sortableTypes = _.compact(_.map(blist.datatypes, function(t, n) {
    return t.sortable ? n : null;
  }));

  var groupableTypes = _.compact(_.map(blist.datatypes, function(t, n) {
    return !$.isBlank(t.rollUpAggregates) ? n : null;
  }));

  var rollUpFunctions = function(colFN) {
    if ($.isBlank(colFN)) {
      return null;
    }
    return this._view.columnForIdentifier(colFN).dataType.rollUpAggregates;
  };

  var groupFunctions = function(colFN) {
    if ($.isBlank(colFN)) {
      return 'hidden';
    }
    return this._view.columnForIdentifier(colFN).dataType.groupFunctions || 'hidden';
  };

  $.Control.extend('pane_sortRollUp', {
    getTitle: function() {
      return $.t('screens.ds.grid_sidebar.sort_rollup.title');
    },

    getSubtitle: function() {
      if (userCanReadParentView) {
        return $.t('screens.ds.grid_sidebar.sort_rollup.subtitle');
      } else {
        return $.t('screens.ds.grid_sidebar.sort_rollup.based_on_private_view');
      }
    },

    isAvailable: function() {
      // EN-29700 - Blue Pane should be disabled on SoQL-based view
      //
      // We need to disable the 'blue pane' controls when the view is defined
      // by a SoQL query, since we will disregard any configuration done via
      // the blue pane in favor of the SoQL query at <view>.queryString in
      // any case.
      if (!_.isUndefined(_.get(this, '_view.queryString'))) {
        return false;
      }

      return isEdit(this) ? this._view.realColumns.length > 0 :
        this._view.visibleColumns.length > 0 && this._view.valid;
    },

    getDisabledSubtitle: function() {
      // EN-29700 - Blue Pane should be disabled on SoQL-based view
      //
      // We need to disable the 'blue pane' controls when the view is defined
      // by a SoQL query, since we will disregard any configuration done via
      // the blue pane in favor of the SoQL query at <view>.queryString in
      // any case.
      if (!_.isUndefined(_.get(this, '_view.queryString'))) {
        return $.t('controls.filter.main.view_is_soql_based_view');
      }

      return !this._view.valid && !isEdit(this) ? $.t('screens.ds.grid_sidebar.base.validation.invalid_view') : $.t('screens.ds.grid_sidebar.sort_rollup.validation.no_eligible_columns');
    },

    _getCurrentData: function() {
      return this._super() || this._view.cleanCopy();
    },

    // SODA 2 does not currently allow grouping by DateTime w/ TimeZone
    _filteredGroupableTypesForSoda2: function(view) {
      return _.filter(groupableTypes, function(type) {
        return view.newBackend ? type != 'date' : true;
      });
    },

    _getSections: function() {

      if (!userCanReadParentView) {
        return [];
      }

      var sects = [];

      // Group section
      sects.push({
        name: 'filterGroup',
        type: 'selectable',
        title: $.t('screens.ds.grid_sidebar.sort_rollup.rollup.title'),
        fields: [{
          type: 'repeater',
          name: 'metadata.jsonQuery.group',
          minimum: 0,
          addText: $.t('screens.ds.grid_sidebar.sort_rollup.rollup.add_group_button'),
          field: {
            type: 'group',
            options: [{
              type: 'columnSelect',
              name: 'columnFieldName',
              notequalto: 'groupColumn',
              useFieldName: true,
              text: $.t('screens.ds.grid_sidebar.sort_rollup.rollup.group_by'),
              columns: {
                type: this._filteredGroupableTypesForSoda2(this._view),
                noDefault: true,
                hidden: isEdit(this) || this._view.isGrouped()
              }
            }, {
              type: 'select',
              name: 'groupFunction',
              text: $.t('screens.ds.grid_sidebar.sort_rollup.rollup.group_function_label'),
              prompt: $.t('screens.ds.grid_sidebar.sort_rollup.rollup.group_function_prompt'),
              options: groupFunctions,
              linkedField: 'columnFieldName'
            }]
          }
        }, {
          type: 'repeater',
          minimum: 0,
          name: 'metadata.jsonQuery.select',
          addText: $.t('screens.ds.grid_sidebar.sort_rollup.rollup.add_rollup_button'),
          field: {
            type: 'group',
            options: [{
              type: 'columnSelect',
              name: 'columnFieldName',
              required: true,
              useFieldName: true,
              text: $.t('screens.ds.grid_sidebar.sort_rollup.rollup.roll_up'),
              notequalto: 'rollUpColumn',
              columns: {
                type: this._filteredGroupableTypesForSoda2(this._view),
                noDefault: true,
                hidden: isEdit(this) || this._view.isGrouped()
              }
            }, {
              type: 'select',
              required: true,
              name: 'aggregate',
              text: $.t('screens.ds.grid_sidebar.sort_rollup.rollup.function'),
              prompt: $.t('screens.ds.grid_sidebar.sort_rollup.rollup.roll_up_function'),
              linkedField: 'columnFieldName',
              options: rollUpFunctions
            }]
          }
        }]
      });

      // Sort section
      sects.push({
        name: 'filterSort',
        type: 'selectable',
        title: $.t('screens.ds.grid_sidebar.sort_rollup.sort.title'),
        fields: [{
          type: 'repeater',
          name: 'metadata.jsonQuery.order',
          minimum: 0,
          addText: $.t('screens.ds.grid_sidebar.sort_rollup.sort.add_column_button'),
          field: {
            type: 'group',
            options: [{
              type: 'columnSelect',
              name: 'columnFieldName',
              required: true,
              notequalto: 'sortColumn',
              useFieldName: true,
              text: $.t('screens.ds.grid_sidebar.sort_rollup.sort.column'),
              columns: {
                type: sortableTypes
              }
            }, {
              type: 'select',
              name: 'ascending',
              prompt: null,
              text: $.t('screens.ds.grid_sidebar.sort_rollup.sort.direction'),
              options: [{
                text: $.t('screens.ds.grid_sidebar.sort_rollup.sort.directions.ascending'),
                value: 'true'
              }, {
                text: $.t('screens.ds.grid_sidebar.sort_rollup.sort.directions.descending'),
                value: 'false'
              }]
            }]
          }
        }]
      });

      return sects;
    },

    shown: function() {
      var cpObj = this;
      cpObj._super();
      if (!cpObj._registeredChange) {
        cpObj._view.bind('query_change', function() {
          cpObj.reset();
        }, cpObj);
        cpObj._registeredChange = true;
      }
    },

    _getFinishButtons: function() {
      return [$.controlPane.buttons.apply, $.controlPane.buttons.cancel];
    },

    _finish: function(data, value, finalCallback) {
      var cpObj = this;
      if (!cpObj._super.apply(cpObj, arguments)) {
        return;
      }

      var forceUseOfModifyingLensIdInAllDerivedViews = _.get(
        window,
        'socrata.featureFlags.force_use_of_modifying_lens_id_in_all_derived_views',
        false
      );

      if (forceUseOfModifyingLensIdInAllDerivedViews) {

        var formValues = cpObj._getFormValues();
        var select = _.get(formValues, 'metadata.jsonQuery.select', []);
        var group = _.get(formValues, 'metadata.jsonQuery.group', []);
        var columnFieldNamesForQuery = select.
          concat(group).
          map(function(argument) {
            return argument.columnFieldName;
          });
        var columns = cpObj._view.jsonColumnsWithoutGroupingsOrAggregations();

        // Note that we are mutating the 'columns' variable here instead of doing a map.
        columns.forEach(function(column) {

          // Only flag hidden if we are looking at some sort of aggregate
          if (!_.isEmpty(columnFieldNamesForQuery) && !_.includes(columnFieldNamesForQuery, column.fieldName)) {

            if (_.isNull(_.get(column, 'flags', null))) {
              column.flags = [];
            }

            column.flags.push('hidden');
          } else {

            var groupingParameters = _.find(group, {columnFieldName: column.fieldName});
            var aggregationParameters = _.find(select, {columnFieldName: column.fieldName});

            if (groupingParameters) {

              if (!column.hasOwnProperty('format')) {
                column.format = {};
              }

              if (groupingParameters.hasOwnProperty('groupFunction')) {
                column.format.group_function = groupingParameters.groupFunction;
              }

              column.format.drill_down = 'true';
            }

            if (aggregationParameters) {

              if (!column.hasOwnProperty('format')) {
                column.format = {};
              }

              var groupingAggregate;

              switch (aggregationParameters.aggregate) {

                case 'avg':
                  groupingAggregate = 'average';
                  break;

                case 'min':
                  groupingAggregate = 'minimum';
                  break;

                case 'max':
                  groupingAggregate = 'maximum';
                  break;

                default:
                  groupingAggregate = aggregationParameters.aggregate;
                  break;
              }

              column.format.grouping_aggregate = groupingAggregate;
            }
          }
        });

        var updatedView = {
          columns: columns,
          metadata: formValues.metadata
        };

        cpObj._view.update(updatedView, true, true);
        cpObj._view.trigger('columns_changed');

        cpObj._finishProcessing();

        _.defer(function() {
          cpObj.reset();
        });

        if (_.isFunction(finalCallback)) {
          finalCallback();
        }

        // Don't forget this return statement, or you'll get very unexpected
        // results when the old code runs after the new code, instead of just
        // the new code running... o_O
        return;
      }

      var filterView = cpObj._getFormValues();
      var md = $.extend(true, {}, cpObj._view.metadata);
      var query = md.jsonQuery;
      // Copy orders & groups over always, because this is truth
      _.each(['order', 'group', 'select'], function(by) {
        query[by] = ((filterView.metadata || {}).jsonQuery || {})[by];
      });
      filterView.metadata = md;

      // Fix up orderBys to be server-compatible
      _.each(filterView.metadata.jsonQuery.order || [], function(ob) {
        ob.ascending = (ob.ascending == 'true' || ob.ascending === true);
      });

      // Only get real group-bys
      if (!_.isEmpty(filterView.metadata.jsonQuery.group)) {
        filterView.metadata.jsonQuery.group = _.filter(filterView.metadata.jsonQuery.group,
          function(gb) {
            return !$.isBlank(gb.columnFieldName);
          });
      }

      // We can't have aggregates with no groupBys
      if (_.some(filterView.metadata.jsonQuery.select, function(s) {
          return !$.isBlank(s.aggregate);
        }) &&
        _.isEmpty(filterView.metadata.jsonQuery.group)) {
        cpObj.$dom().find('.mainError').text($.t('screens.ds.grid_sidebar.sort_rollup.validation.no_group_bys'));
        cpObj._finishProcessing();
        return;
      }

      // We also can't have any aggregates without a function
      if (!_.isEmpty(filterView.metadata.jsonQuery.group) &&
        _.some(filterView.metadata.jsonQuery.select, function(s) {
          return $.isBlank(s.aggregate) && !_.some(filterView.metadata.jsonQuery.group,
            function(g) {
              return g.columnFieldName == s.columnFieldName;
            });
        })) {
        cpObj.$dom().find('.mainError').text($.t('screens.ds.grid_sidebar.sort_rollup.validation.no_function'));
        cpObj._finishProcessing();
        return;
      }

      var updatedCols = false;
      // Make new columns have the correct format
      _.each(filterView.metadata.jsonQuery.group, function(g) {
        var col = cpObj._view.columnForIdentifier(g.columnFieldName);

        var r = Column.closestViewFormat(col,
          blist.datatypes.groupFunctionFromSoda2(g.groupFunction));
        if (!$.isBlank(r)) {
          var fmt = $.extend({}, col.format);
          fmt.view = r;
          col.update({
            format: fmt
          });
          updatedCols = true;
        }
      });

      // Clear out any previously-set values on columns that have now been un-set
      _.each(cpObj._view.realColumns, function(c) {
        if ((!$.isBlank(c.format.group_function) || !$.isBlank(c.format.grouping_aggregate)) &&
          !_.some(filterView.metadata.jsonQuery.select, function(s) {
            return !$.isBlank(s.aggregate) && s.columnFieldName == c.fieldName;
          }) &&
          !_.some(filterView.metadata.jsonQuery.group, function(g) {
            return g.columnFieldName == c.fieldName;
          })) {
          var fmt = $.extend({}, c.format);
          var r = Column.closestViewFormat(c, null);
          if (!$.isBlank(r)) {
            fmt.view = r;
          }
          delete fmt.grouping_aggregate;
          delete fmt.group_function;
          c.update({
            format: fmt
          });
          updatedCols = true;
        }
      });

      var wasInvalid = !cpObj._view.valid;

      // Now do the real update
      cpObj._view.update(filterView, false, _.isEmpty(filterView.metadata.jsonQuery.group));
      if (updatedCols) {
        cpObj._view.trigger('columns_changed');
      }

      var finishCallback = function() {
        cpObj._finishProcessing();

        _.defer(function() {
          cpObj.reset();
        });
        if (_.isFunction(finalCallback)) {
          finalCallback();
        }
      };

      // If we were invalid and can save, then do so
      if (wasInvalid && cpObj._view.type != 'blist') {
        if (!cpObj._view.save(finishCallback)) {
          finishCallback();
        }
      } else {
        finishCallback();
      }
    }

  }, {
    name: 'sortRollUp'
  }, 'controlPane');

  var isEdit = function(cpObj) {
    return cpObj._view.isGrouped() && cpObj._view.hasRight(blist.rights.view.UPDATE_VIEW);
  };

  $(document).ready(function() {
    var showPane = _.get(window, 'socrata.gridView.sidebarPaneVisibility.filter.sortRollUp', false);
    var useSCGCDerivedViewsModel = _.get(window, 'socrata.featureFlags.force_use_of_modifying_lens_id_in_all_derived_views', false);

    if (showPane) {

      if (useSCGCDerivedViewsModel) {
        blist.dataset.getParentView(function(parDS) {
          userCanReadParentView = !$.isBlank(parDS);
          $.gridSidebar.registerConfig('filter.sortRollUp', 'pane_sortRollUp', 3, 'grouped');
          blist.datasetPage.updateSidebarLinks();
        });
      } else {
        userCanReadParentView = true;
        $.gridSidebar.registerConfig('filter.sortRollUp', 'pane_sortRollUp', 3, 'grouped');
      }
    }
  });
})(jQuery);
